const mrCollaborators = [
    {
        name: "John Carmack",
        count: 12,
    },
    {
        name: "John Romero",
        count: 5,
    },
    {
        name: "Sandy Petersen",
        count: 9,
    },
];

const mrsPerProject = {
    merged: [
        {
            name: "backend-server",
            count: 3,
        },
        {
            name: "frontend-b2c",
            count: 15,
        },
        {
            name: "devops / terraform",
            count: 1,
        },
    ],
    mergedToDefault: [
        {
            name: "backend-server",
            count: 1,
        },
        {
            name: "frontend-b2c",
            count: 5,
        },
    ],
    mergedToOther: [
        {
            name: "backend-server",
            count: 2,
        },
        {
            name: "frontend-b2c",
            count: 10,
        },
        {
            name: "devops / terraform",
            count: 1,
        },
    ],
    open: [
        {
            name: "backend-server",
            count: 8,
        },
        {
            name: "frontend-b2c",
            count: 15,
        },
        {
            name: "devops / terraform",
            count: 7,
        },
    ],
};

const stuckMrs = [
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend B2C",
        pull_number: 598,
        created_at_ts: "2024-06-17 16:28:53",
        title: "Extra settings handling",
        mr_html_url: "https://gitlab.com/",
    },
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend B2C",
        pull_number: 564,
        created_at_ts: "2024-05-23 14:36:40",
        title: "MVP-944: Overview demo",
        mr_html_url: "https://gitlab.com/",
    },
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend B2C",
        pull_number: 475,
        created_at_ts: "2023-11-27 13:43:21",
        title: "MVP-887: Updated size limits",
        mr_html_url: "https://gitlab.com/adadot/",
    },
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend B2C",
        pull_number: 473,
        created_at_ts: "2023-11-14 15:57:31",
        title: "MVP-900: Advanced settings",
        mr_html_url: "https://gitlab.com/",
    },
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend Static",
        pull_number: 65,
        created_at_ts: "2023-09-26 13:49:18",
        title: "personal profile outline",
        mr_html_url: "https://gitlab.com/",
    },
    {
        hostname_repo_full_name: "https://gitlab.com:demo / Frontend B2C",
        pull_number: 310,
        created_at_ts: "2023-04-25 15:45:01",
        title: "limit datepicker",
        mr_html_url: "https://gitlab.com/",
    },
];

const stats = {
    totalMrsMerged: 3,
    totalMrsClosed: 1,
    totalMrsOpen: 2,
    avgLinesMergedPerMr: 1265,
    avgLinesMergedPerMrDefault: 2354,
    avgLinesMergedPerMrOther: 564,
    avgLinesMergedPerOpen: 3321,
    avgCommitsPerMr: 7,
    avgCommitsPerMrDefault: 3,
    avgCommitsPerMrOther: 5,
    avgCommitsPerMrOpen: 10,
    mergesPerDay: 21,
    approvalRateOnMyMrs: 1,
    totalCommentsReceived: 21,
    baseline: {
        totalMrsMerged: 3,
        totalMrsClosed: 2,
        totalMrsOpen: 5,
        avgLinesMergedPerMr: 700,
        avgLinesMergedPerMrDefault: 2000,
        avgLinesMergedPerMrOther: 855,
        avgCommitsPerMr: 4,
        avgCommitsPerMrDefault: 4,
        avgCommitsPerMrOther: 5,
        mergesPerDay: 21,
        approvalRateOnMyMrs: 0.8,
        totalCommentsReceived: 30,
    },
};

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const getMergeRequests = () => {
    return {
        mrsPerProject,
        mrCollaborators,
        stuckMrs,
        stats,
        meta,
    };
};

export default getMergeRequests;
